// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"b6c72921","330":"0a1c6a5e","442":"1b596c85","710":"325485be"}[chunkId] + ".chunk.js";
};